import React from 'react';
import { observer } from 'mobx-react';

interface SieveFactorFieldsProps {
  processTypeId: number;
  processTypeName: string;
  sieveFactor?: {
    id?: number;
    sieve_0_percentage?: string;
    sieve_12_percentage?: string;
    sieve_14_percentage?: string;
    sieve_15_percentage?: string;
    factor_14?: string;
    factor_15?: string;
    _destroy?: boolean;
  };
  index: number;
}

function SieveFactorFields({
  processTypeId,
  processTypeName,
  sieveFactor,
  index,
}: SieveFactorFieldsProps) {
  const attributeString = `fixed_price_contract[sieve_factors_attributes][${index}]`;
  const isDestroyed = sieveFactor?._destroy;

  return (
    <div style={{ marginBottom: '2rem' }}>
      {/* Process Type Header */}
      <h4
        style={{
          fontWeight: 700,
          marginBottom: '1rem',
        }}
      >
        {processTypeName}
      </h4>

      {/* Hidden fields for Rails nested attributes */}
      {sieveFactor?.id && (
        <input type='hidden' name={`${attributeString}[id]`} value={sieveFactor.id} />
      )}

      <input
        type='hidden'
        name={`${attributeString}[process_type_id]`}
        value={processTypeId}
      />

      {sieveFactor?._destroy && (
        <input type='hidden' name={`${attributeString}[_destroy]`} value='1' />
      )}

      {!isDestroyed && (
        <div
          className='l-auto-fill-grid'
          style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(12em, 1fr))' }}
        >
          <div className='input-group'>
            <label htmlFor={`${attributeString}[sieve_0_percentage]`}>Sieve 0</label>
            <div className='input-group__row'>
              <input
                type='text'
                id={`${attributeString}[sieve_0_percentage]`}
                name={`${attributeString}[sieve_0_percentage]`}
                defaultValue={sieveFactor?.sieve_0_percentage || ''}
                placeholder=' '
                required
              />
              <span className='input-group__append'>
                <span>%</span>
              </span>
            </div>
          </div>

          <div className='input-group'>
            <label htmlFor={`${attributeString}[sieve_12_percentage]`}>Sieve 12</label>
            <div className='input-group__row'>
              <input
                type='text'
                id={`${attributeString}[sieve_12_percentage]`}
                name={`${attributeString}[sieve_12_percentage]`}
                defaultValue={sieveFactor?.sieve_12_percentage || ''}
                placeholder=' '
                required
              />
              <span className='input-group__append'>
                <span>%</span>
              </span>
            </div>
          </div>

          <div className='input-group'>
            <label htmlFor={`${attributeString}[sieve_14_percentage]`}>Sieve 14</label>
            <div className='input-group__row'>
              <input
                type='text'
                id={`${attributeString}[sieve_14_percentage]`}
                name={`${attributeString}[sieve_14_percentage]`}
                defaultValue={sieveFactor?.sieve_14_percentage || ''}
                placeholder=' '
                required
              />
              <span className='input-group__append'>
                <span>%</span>
              </span>
            </div>
          </div>

          <div className='input-group'>
            <label htmlFor={`${attributeString}[sieve_15_percentage]`}>Sieve 15</label>
            <div className='input-group__row'>
              <input
                type='text'
                id={`${attributeString}[sieve_15_percentage]`}
                name={`${attributeString}[sieve_15_percentage]`}
                defaultValue={sieveFactor?.sieve_15_percentage || ''}
                placeholder=' '
                required
              />
              <span className='input-group__append'>
                <span>%</span>
              </span>
            </div>
          </div>

          <div className='input-group'>
            <label htmlFor={`${attributeString}[factor_14]`}>Factor 14</label>
            <div className='input-group__row'>
              <input
                type='text'
                id={`${attributeString}[factor_14]`}
                name={`${attributeString}[factor_14]`}
                defaultValue={sieveFactor?.factor_14 || ''}
                placeholder=' '
                required
              />
              <span className='input-group__append'>
                <span>%</span>
              </span>
            </div>
          </div>

          <div className='input-group'>
            <label htmlFor={`${attributeString}[factor_15]`}>Factor 15</label>
            <div className='input-group__row'>
              <input
                type='text'
                id={`${attributeString}[factor_15]`}
                name={`${attributeString}[factor_15]`}
                defaultValue={sieveFactor?.factor_15 || ''}
                placeholder=' '
                required
              />
              <span className='input-group__append'>
                <span>%</span>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default observer(SieveFactorFields);
